export const environment = {
  production: false,
  apiUrl: 'https://api-dev-inventory.azurewebsites.net/api',
};
